import {
    Search,
    Filter,
} from "lucide-react";

import "./CategoryFilters.css";

function CategoryFilters({
    filters,
    onChange,
}) {

    return (

        <div className="category-filters">

            <div className="search-box">

                <Search size={18} />

                <input
                    type="text"
                    placeholder="Search by Category Name or Slug..."
                    value={filters.search}
                    onChange={(e) =>
                        onChange("search", e.target.value)
                    }
                />

            </div>

            <div className="filter-item">

                <Filter size={18} />

                <select
                    value={filters.status}
                    onChange={(e) =>
                        onChange("status", e.target.value)
                    }
                >

                    <option value="">
                        All Status
                    </option>

                    <option value="true">
                        Active
                    </option>

                    <option value="false">
                        Inactive
                    </option>

                </select>

            </div>

            <div className="filter-item">

                <select
                    value={filters.featured}
                    onChange={(e) =>
                        onChange("featured", e.target.value)
                    }
                >

                    <option value="">
                        All Featured
                    </option>

                    <option value="true">
                        Featured
                    </option>

                    <option value="false">
                        Not Featured
                    </option>

                </select>

            </div>

            <div className="filter-item">

                <select
                    value={filters.popular}
                    onChange={(e) =>
                        onChange("popular", e.target.value)
                    }
                >

                    <option value="">
                        All Popular
                    </option>

                    <option value="true">
                        Popular
                    </option>

                    <option value="false">
                        Not Popular
                    </option>

                </select>

            </div>

        </div>

    );

}

export default CategoryFilters;